import { AcessoProntuarioService } from '../../core/http/service/AcessoProntuario';

const sendToAnalytics = (action: string = '', error: any = null) => {
    console.error(action, error);
}

export const registrarJustificativa = (profissionalId: string, pacienteId: string, justificativaAcessoProntuario: string) => {
    
    return async (dispatch: any) => {
        const services = new AcessoProntuarioService();
        try {
                   
            const object = {  
                "profissionalId": profissionalId,  
                "pacienteId": pacienteId,  
                "justificativaAcessoProntuario": justificativaAcessoProntuario
            }
            
            await services.registrarJustificativa(object)

        } catch (error: any) {
            sendToAnalytics(error);
            throw error;
        }
    }
}